<app-header></app-header>

<!-- Container -->
<section class="content legal-notice-block">

    <div class="legal-notice-block__title">
        <h1 class="text-h1">Aviso Legal</h1>
    </div>
    <div class="legal-notice-block__content">
        <div class="">
            <p>Información Legal sobre Stratesys Technology Solutions</p>
        </div>
        <div class="">
            <p>Stratesys Technology Solutions, Inscripción R.M. de Madrid, Tomo 20.440, Libro 0, Folio 132, Sección 8, Hoja M-201137, Inscripción 16ª CIF B81866014</p>
        </div>

        <div class="legal-notice-block__direction">
            <div class="column-4">
                <p><strong>MADRID</strong></p>
                <p>C/ Torrelaguna 77</p>
                <p>28043 Madrid</p>
            </div>
            <div class="column-4">
                <p><strong>SEVILLA</strong></p>
                <p>C/ Luis Montoto nº 107/113, Edificio Cristal A, 2ª Pl módulos A y B</p>
                <p>41007 Sevilla</p>
            </div>
            <div class="column-4">
                <p><strong>BARCELONA</strong></p>
                <p>Ronda Sant Pere, 17, Barcelona</p>
                <p>08010 Barcelona</p>
            </div>
        </div>

        <div class="legal-notice-block__direction">
            <div class="column-4">
                <p><strong>VALENCIA</strong></p>
                <p>Paseo de la Alameda, 34</p>
                <p>46023 Valencia</p>
            </div>
            <div class="column-4">
                <p><strong>OVIEDO</strong></p>
                <p>C/ Azcárraga, 26</p>
                <p>33010 Oviedo</p>
            </div>
            <div class="column-4">
                <p><strong>A CORUÑA</strong></p>
                <p>Calle Copérnico, 1</p>
                <p>15008 A Coruña</p>
            </div>
        </div>

        <div class="">
            <p>La información contenida en este sitio web, está destinada a proporcionar a los usuarios información general sobre asuntos que pueden ser de su interés. Si bien se han hecho todos los esfuerzos para ofrecer información actual y precisa, pueden ocurrir errores.</p>
        </div>
        <div class="">
            <p>Todo el contenido y/o servicios proporcionados a través del mismo se proporcionan “tal cual”, sin garantías de integridad, exactitud o puntualidad, y sin declaraciones, u otros términos contractuales de ningún tipo, expresos o implícitos.</p>
        </div>
        <div class="">
            <p>Hasta el grado máximo permitido por la legislación vigente, Stratesys declina toda responsabilidad con usted o cualquier tercero, respecto al contenido de este sitio web y todos los servicios proporcionados a través de él, ya sea bajo cualquier teoría de agravio, contrato, garantía, responsabilidad estricta o negligencia o de otra manera, ya sea por daños directos, indirectos, consecuenciales, especiales, punitivos o similares, incluso si fueron advertidos, o se debía haber conocido la posibilidad de dichos daños.</p>
        </div>
        <div class="">
            <p>Así mismo, este sitio web contiene hipervínculos a sitios web pertenecientes o gestionados por terceros. Stratesys no asume ningún tipo de responsabilidad respecto a los contenidos de los mismos así como los datos que se puedan recoger en ellos.</p>
        </div>
        <div class="">
            <h4 class="text-h4">Alcance de las Certificaciones ISO</h4>
        </div>
        <div class="">
            <p>El alcance de nuestras certificaciones ISO aplica a nuestra sede corporativa central (ubicada en Madrid C/Torrelaguna, 77) y hace referencia a los servicios y proyectos de:</p>
        </div>
        <div class="">
            <p>Diseño, construcción, implantación y mantenimiento de soluciones tecnológicas y sistemas de información</p>
            <p>Estudio y definición de modelos de mejora e innovación de procesos y sistemas</p>
            <p>En Stratesys disponemos de una Política de Calidad que ponemos a disposición de empleados, clientes, proveedores y partners que estén interesados en conocerla (enviando email solicitándola a
              <a class="color-brand link" href="mailto:info_mad@stratesys-ts.com">info_mad@stratesys-ts.com</a>)</p>
        </div>
        <div class="">
            <p>© Stratesys – Todos los derechos reservados</p>
        </div>
    </div>

</section>

<app-footer></app-footer>
